export default {
  path: '/store-index',
  meta: {
    title: '联盟商家',
    tab:true,
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/store-index`),
}



// WEBPACK FOOTER //
// ./src/views/StoreIndex/router.js